import StockConfiguration from "@/components/stock/configuration/stock-configuration";
import { createFileRoute } from "@tanstack/react-router";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

export const Route = createFileRoute(
  "/_authenticated/settings/_layout/inventory/",
)({
  component: InventorySettingsPage,
});

function InventorySettingsPage() {
  return (
    <RouteGuardPermissions
      permissions={[{ module: "stock_configurations", actions: ["read", "update"] }]}
    >
      <div className="gap-2 flex-col flex">
        <StockConfiguration module="stock_configurations" />
      </div>
    </RouteGuardPermissions>
  );
}
